import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Form, Input, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import {doc, getDoc} from "firebase/firestore";
import {getDb} from "../../util/Constants";
import Swal from "sweetalert2";

const AssessmentInfo = (props) => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [userType, setUserType] = useState(props.signedInUser.projectType);
    const [formData, setFormData] = useState({
        assessmentName: "",
        assessmentFor: "",
        difficulty: "Easy",
        candidateFlow: false
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.userData.eventData) {

            setFormData(props.userData.eventData);
        }
    }, [])
    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        const userCompanyKey = props.signedInUser.companyName.toLowerCase().replace(/\s/g, "");
        const assessmentKey = formData.assessmentName.toLowerCase().replace(/\s/g, "");
        const eventId = userCompanyKey + "_" + assessmentKey;
        const docRef = doc(getDb(), "Events", eventId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {

            setLoading(false);
            return Swal.fire({
                title: 'Error!',
                text: 'Assessment with this name already created',
                icon: 'error',
            });
        } else {

            let gameLink = "";

            // temporary code
            // free domain link when enable creating plan base new domain
            // gameLink = "https://freeplayace.activ8games.com/?game=" + props.signedInUser.companyName.replace(/\s/g, "") + "_" + formData.assessmentName.replace(/\s/g, "");
            // live link
            // gameLink = "https://ace-game.activ8games.com/?game=" + props.signedInUser.companyName.replace(/\s/g, "") + "_" + formData.assessmentName.replace(/\s/g, "") + '&accesscode=PKGACCESSSPECIAL';
            // public link
            // gameLink = "https://ace-public-live.web.app/?game=" + props.signedInUser.companyName.replace(/\s/g, "") + "_" + formData.assessmentName.replace(/\s/g, "");
            // gameLink = "https://progress-fb.web.app/?game=" + props.signedInUser.companyName.replace(/\s/g, "") + "_" + formData.assessmentName.replace(/\s/g, "");
            // gameLink = "https://progress-80e58.web.app/?game=" + props.signedInUser.companyName.replace(/\s/g, "") + "_" + formData.assessmentName.replace(/\s/g, "");
            //  working code --------------------------------------------
            // gameLink = " https://pepsico-progress.activ8games.com/?game=" + eventId;
            // gameLink = "https://progress-public-live.web.app?game=" + eventId;
            gameLink = "https://ace-game.activ8games.com/?game=" + eventId;
            // gameLink = "https://progress-public-live-new.web.app/?game=" + eventId;
            

            props.setUserData({
                ...props.userData,
                eventData:
                    {
                        ...props.userData.eventData,
                        assessmentName: formData.assessmentName,
                        assessmentFor: formData.assessmentFor,
                        difficulty: formData.difficulty ?? "Easy",
                        candidateFlow: formData.candidateFlow ?? false,
                        eventId: eventId,
                        gameLink: gameLink
                        // companyName: formData.companyName
                    }
            });
            setLoading(false);
            history.push("/assessment/behavioral");


            // plan base domain creation
            // if (props.signedInUser.plan === "free") {
            //     gameLink = "https://freeplayace.activ8games.com/?game=" + props.signedInUser.companyName.replace(/\s/g, "") + "_" + formData.assessmentName.replace(/\s/g, "");
            //     props.setUserData({
            //         ...props.userData,
            //         eventData:
            //             {
            //                 ...props.userData.eventData,
            //                 assessmentName: formData.assessmentName,
            //                 assessmentFor: formData.assessmentFor,
            //                 difficulty: formData.difficulty ?? "Easy",
            //                 candidateFlow: formData.candidateFlow ?? false,
            //                 eventId: eventId,
            //                 gameLink: gameLink
            //                 // companyName: formData.companyName
            //             }
            //     });
            //     setLoading(false);
            //     history.push("/assessment/behavioral");
            //     console.log(gameLink, "Game Link created");
            // } else if (props.signedInUser.plan === "premium" || props.signedInUser.plan === "standard") {
            //     console.log("Calling Api to create domain");
            //     let data = {
            //         "name": props.signedInUser.companyKey
            //         // "name": "new-domain"
            //     };
            //     let config = {
            //         method: 'post',
            //         maxBodyLength: Infinity,
            //         url: 'https://9czl6wwmvh.execute-api.us-west-2.amazonaws.com/default/progress008',
            //         headers: {
            //             'Content-Type': 'application/json'
            //         },
            //         data: data
            //     };
            //     axios.request(config).then(res => {
            //         console.log(res, "Response");
            //         gameLink = res.data.domain + "/?game=" + props.signedInUser.companyName.replace(/\s/g, "") + "_" + formData.assessmentName.replace(/\s/g, "");
            //         props.setUserData({
            //             ...props.userData,
            //             eventData:
            //                 {
            //                     ...props.userData.eventData,
            //                     assessmentName: formData.assessmentName,
            //                     assessmentFor: formData.assessmentFor,
            //                     difficulty: formData.difficulty ?? "Easy",
            //                     candidateFlow: formData.candidateFlow ?? false,
            //                     eventId: eventId,
            //                     gameLink: gameLink
            //                     // companyName: formData.companyName
            //                 }
            //         });
            //         setLoading(false);
            //         history.push("/assessment/behavioral");
            //     }).catch(error => {
            //         console.log(error, "Error");
            //     })
            // }
        }
    }
    return (
        <Container className="ml-0 right-content-container">
            <Row className="">
                <Col>
                    <h1 className="">Tell us about
                        your {userType === "progress" ? 'Game' : 'Assessment'}</h1>
                    <hr className="mb-0 mt-1 heading-hr mx-2"/>
                </Col>
            </Row>
            <div>
                <Form onSubmit={handleSubmit}>
                    <h2 className="active-text-color">{userType === "progress" ? 'Game' : 'Assessment'} Information</h2>
                    <div className="mt-4">
                        <div className="inner-assessment-content">
                            <Row>
                                <Col lg={6} sm={12}>
                                    <div>
                                        <Input
                                            className="assessment-input"
                                            placeholder="Your Game Name"
                                            value={formData.assessmentName}
                                            required
                                            onChange={(e) => {
                                                setFormData({...formData, assessmentName: e.target.value});
                                            }}
                                        />
                                        <label className="fs-14 ml-2 font-weight-600">Name
                                            your {userType === "progress" ? 'game' : 'assessment game'}</label>
                                    </div>
                                </Col>
                                <Col lg={6} sm={12}>
                                    <Input className="assessment-input"
                                           value={formData.assessmentFor}
                                           required
                                           onChange={(e) => {
                                               setFormData({...formData, assessmentFor: e.target.value});
                                           }}
                                           placeholder={userType === "progress" ? 'Game For' : 'Assessment For'}/>
                                    <label className="fs-14 ml-2 font-weight-600">Let us know who you are hiring</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={6} sm={12}>
                                    <div>
                                        <Input className="assessment-input" onChange={(e) => {
                                            setFormData({...formData, difficulty: e.target.value})
                                        }} type="select" name="selectMulti" value={formData.difficulty}>
                                            <option value={'Easy'}>Easy</option>
                                            <option value={'Hard'}>Hard</option>
                                        </Input>
                                        <label className="fs-14 ml-2 font-weight-600">Difficulty</label>
                                    </div>
                                </Col>
                                <Col lg={6} sm={12}></Col>
                            </Row>
                            {userType === "progress" ? "" :
                                <>
                                    <div className="mt-4">
                                        <input
                                            className="auth-checkbox mx-2"
                                            type="checkbox"
                                            id="selectAll"
                                            name="selectAll"
                                            checked={formData.candidateFlow}
                                            onChange={(e) => {
                                                setFormData({...formData, candidateFlow: e.target.checked});
                                            }}
                                        />
                                        <label className='radio-label' htmlFor="selectAll">Enable Candidate Flow</label>
                                    </div>
                                    <span className="fs-12">Enabling this would allow potential candidates to fill their information before <br/> attempting the investment</span>
                                </>
                            }
                        </div>
                        <Row className="buttons-div">
                            <Col sm={12} xs={12} md={3} lg={7}></Col>
                            <Col sm={12} xs={12} md={6} lg={3}>
                                {/*<Button className="previous-button text-white w-100" type="button"*/}
                                {/*        color="">Request for demo video</Button>*/}
                            </Col>
                            <Col sm={12} xs={12} md={3} lg={2}>
                                <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                    // onClick={handleSubmit}
                                        disabled={loading}
                                        type="submit"
                                        color="">
                                    {loading ? <>
                                    <span className="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                                        <span className="sr-only">Loading...</span>
                                    </> : "Next"}
                                </Button>
                            </Col>
                        </Row>
                        {/*<div className="buttons-div">*/}
                        {/*    <div className="d-flex align-items-center" role="button">*/}
                        {/*        <span className="text-dark font-weight-600 mx-2">Request for Demo Video</span>*/}
                        {/*        <img src={demoButton} alt="" height={17}/>*/}
                        {/*    </div>*/}
                        {/*    <div className="btn-vr"/>*/}
                        {/*    <div className="d-flex align-items-center" role="button" onClick={submitForm}>*/}
                        {/*        <span className="font-weight-600 mx-2 active-text-color">Next</span>*/}
                        {/*        <img src={nextButton} alt="" height={17}/>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </Form>
            </div>
        </Container>
    );
};

export default AssessmentInfo;
